<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3" sm="5" xs="12">
                                <v-select :items="arrYear" v-model="selectedYear" label="Anno"
                                    @change="listaIncassiData(selectedYear, selectedShop)" item-text="description"
                                    item-value="id">
                                </v-select>
                            </v-col>
                            <v-col md="3" sm="5" xs="12">
                                <div>
                                    <v-select :items="arrShops" v-model="selectedShop" label="Negozi"
                                        @change="listaIncassiData(selectedYear, selectedShop)" item-text="description"
                                        item-value="id">
                                    </v-select>
                                </div>
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-expansion-panels v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <b>TOTALI</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <div v-if="listaIncassi.length > 0">
                                <v-row>
                                    <v-col>
                                        Incasso: <b>{{ totali.incasso | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Nr.Scontrini: <b>{{ totali.num_scontrini }} </b>
                                    </v-col>
                                    <v-col>
                                        Media Scontrino: <b>{{ totali.media_scontrino | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Media Ingressi: <b>{{ totali.media_scontrino_anno }}</b>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        Giorni Lavorativi: <b>{{ otherData.giorni_lavorativi || 0 }}</b>
                                    </v-col>
                                    <v-col>
                                        Fatturato Giornaliero Medio: <b>{{ otherData.fatturato_giornaliero_medio | formatEuro }}</b>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-data-table :hide-default-footer="true" :headers="headers" :items="listaIncassi" :items-per-page="15" item-key="id"
                    class="elevation-1" :loading="loading" loading-text="Caricamento in corso...">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Lista Incassi</v-toolbar-title>
                        </v-toolbar>
                    </template>

                    <template v-slot:header.fatturato_mq="{ header }">
                        {{ header.text }} ({{ getMetriQuadri(selectedShop) }})
                    </template>
                    <template v-slot:item.incasso="{ item }">
                        <b>{{ item.incasso | formatEuro }}</b>
                    </template>
                    <template v-slot:item.mese="{ item }">
                        <b>{{ item.mese }}</b>
                    </template>
                    <template v-slot:media_scontrino.iva4="{ item }">
                        {{ item.media_scontrino | formatEuro }}
                    </template>
                    <template v-slot:item.fatturato_mq="{ item }">
                        {{ item.fatturato_mq | formatEuro }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep {

    .background-blue {
        background-color: aqua;
    }

    .background-green {
        background-color: greenyellow;
    }

    .v-data-table-header {
        background-color: #dddddd;

    }

}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: black;
}
</style>
<script>
import requests from "../../requests";
export default {
    name: "kpi-page",
    computed: {
        headers() {
            return [
                { text: "Mese", value: "mese", divider: true },
                { text: "Incassi", value: "incasso", class: "background-blue", divider: true },
                { text: "Nr.Scontrini", value: "num_scontrini", class: "background-green", divider: true },
                { text: "Media Scontrino", value: "media_scontrino", divider: true },
                { text: "Conta persone", value: "conta_persone", divider: true },
                { text: "Ingresso / Scontrini", value: "scontrini_ingressi", divider: true },
                { text: "Fatturaro MQ", value: "fatturato_mq", divider: true },
            ]
        }
    },
    data: () => {
        return {
            menu: false,
            selectedYear: null,
            loading: false,
            arrYear: [],
            listaIncassi: [],
            dialog: false,
            arrShops: [],
            selectedShop: 0,
            editIncasso: {},
            panel: 0,
            totali: {},
            otherData: {}
        };
    },
    mounted() {
        console.log("Incassi List Mounted.");
        this.selectedYear = this.$moment().format('YYYY');
        this.loading = true;

        for (let i = this.selectedYear; i >= (this.selectedYear - 10); i--) {
            this.arrYear.push({
                id: i,
                description: i
            });
        }
        this.getShopList();
    },
    methods: {
        onCloseDialog() {
            this.dialog = false;
        },
        getShopList() {
            requests.getShopList().then(res => {
                this.arrShops = res.data;
                this.selectedShop = this.arrShops[0].id;
                this.listaIncassiData(this.selectedYear, this.selectedShop);
            })
        },
        listaIncassiData(dIni, shopId) {
            requests.getKpi(dIni, shopId).then(res => {
                this.listaIncassi = res.data.table_data;
                this.otherData = res.data.other_data;
                this.calcoloTotali(res.data.table_data);
                this.loading = false;
            });
        },

        getShopById(id) {
            return _.find(this.arrShops, { id: id });
        },

        getMetriQuadri(id) {
            let shop = _.find(this.arrShops, { id: id });
            if (shop)
                return shop.metri_quadri
            return '';
        },

        calcoloTotali(datiTotali) {
            this.totali = {};
            let arrField = [
                'incasso', 'conta_persone', 'fatturato_mq', 'media_scontrino',
                'num_scontrini', 'scontrini_ingressi'
            ];

            _.forEach(arrField, (field) => {
                _.forEach(datiTotali, (value) => {
                    if (_.isUndefined(this.totali[field])) {
                        this.$set(this.totali, field, 0);
                    }
                    this.totali[field] += value[field]
                });
            });

            this.totali['media_scontrino'] = this.totali.incasso / this.totali.num_scontrini;
            var num = Math.round((this.totali.conta_persone / this.listaIncassi.length + Number.EPSILON) * 100) / 100
            this.totali['media_scontrino_anno'] = num;
        }
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    }
};
</script>
